import React from 'react';
import Seo from '../components/Seo';

const news = [
  { id: 1, title: 'Welcome!', content: 'The Vine Centre website is live.' }
];

function News() {
  return (
    <section id="news">
      <Seo
        title="News & Announcements | Vine Centre Belfast"
        description="Latest news and announcements from the Vine Centre, serving the North Belfast community."
      />
      <h2>News & Announcements</h2>
      <ul>
        {news.map(item => (
          <li key={item.id}>
            <strong>{item.title}</strong>
            <p>{item.content}</p>
          </li>
        ))}
      </ul>
    </section>
  );
}

export default News;
